var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ValidationObserver",
    [
      _c("ValidationProvider", {
        attrs: { name: "Company name", rules: "required_field" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ errors }) {
              return [
                _c("FormGroup", {
                  attrs: {
                    name: "company name",
                    inputClass: "fullwidthInput",
                    isIcon: false,
                    placeholder: "Enter company name",
                    errors: errors,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _c("span", { staticClass: "required-icon" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(" Company Name "),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.companyName,
                    callback: function ($$v) {
                      _vm.companyName = $$v
                    },
                    expression: "companyName",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("ValidationProvider", {
        attrs: { name: "Job title", rules: "required_field" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ errors }) {
              return [
                _c("FormGroup", {
                  attrs: {
                    name: "job title",
                    isIcon: false,
                    inputClass: "fullwidthInput",
                    placeholder: "Enter job title",
                    errors: errors,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2 mt-2" }, [
                              _c("span", { staticClass: "required-icon" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(" Job Title "),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.jobTitle,
                    callback: function ($$v) {
                      _vm.jobTitle = $$v
                    },
                    expression: "jobTitle",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("ValidationProvider", {
        attrs: { name: "Location", rules: "required_field" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ errors }) {
              return [
                _c("FormGroup", {
                  attrs: {
                    name: "location",
                    isIcon: false,
                    placeholder: "Enter location",
                    inputClass: "fullwidthInput",
                    errors: errors,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2 mt-2" }, [
                              _c("span", { staticClass: "required-icon" }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(" Location "),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.location,
                    callback: function ($$v) {
                      _vm.location = $$v
                    },
                    expression: "location",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "mt-1 grid grid-cols-2 mt-2 gap-8" },
        [
          _c("ValidationProvider", {
            attrs: {
              vid: "start_date",
              name: "Start date",
              rules: "noFutureDate:@ongoing",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ errors }) {
                  return [
                    _c(
                      "FormGroup",
                      {
                        attrs: {
                          title: "Start Date",
                          name: "start date",
                          errors: errors,
                        },
                      },
                      [
                        _c("FormDatepicker", {
                          attrs: { heightClass: "datePickerHeight" },
                          model: {
                            value: _vm.startDate,
                            callback: function ($$v) {
                              _vm.startDate = $$v
                            },
                            expression: "startDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "div",
            [
              _c("ValidationProvider", {
                attrs: {
                  vid: "end_date",
                  name: "End date",
                  rules: "noBeforeDate:@start_date,@ongoing",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ errors }) {
                      return [
                        _c(
                          "FormGroup",
                          {
                            attrs: {
                              title: "End Date",
                              name: "end date",
                              errors: errors,
                            },
                          },
                          [
                            _c("FormDatepicker", {
                              attrs: {
                                disabled: _vm.ongoing,
                                heightClass: "datePickerHeight",
                              },
                              model: {
                                value: _vm.endDate,
                                callback: function ($$v) {
                                  _vm.endDate = $$v
                                },
                                expression: "endDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "ValidationProvider",
                { attrs: { vid: "ongoing", name: "Ongoing" } },
                [
                  _c("div", { staticClass: "flex items-start mt-2" }, [
                    _c("div", { staticClass: "flex items-center h-5" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.ongoing,
                            expression: "ongoing",
                          },
                        ],
                        staticClass:
                          "form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.ongoing)
                            ? _vm._i(_vm.ongoing, null) > -1
                            : _vm.ongoing,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.ongoing,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.ongoing = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.ongoing = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.ongoing = $$c
                            }
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "ml-1 text-sm leading-5" }, [
                      _c(
                        "label",
                        {
                          staticClass: "font-medium text-gray-700",
                          attrs: { for: "comments" },
                        },
                        [_vm._v(" Ongoing? ")]
                      ),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "FormGroup",
        { staticClass: "mt-2", attrs: { title: "Note" } },
        [
          _c("FormTextarea", {
            attrs: {
              customBorderClass: "borderTen",
              placeholder: "Summary",
              name: "experience summary",
            },
            model: {
              value: _vm.summary,
              callback: function ($$v) {
                _vm.summary = $$v
              },
              expression: "summary",
            },
          }),
        ],
        1
      ),
      _c(
        "FormGroup",
        { staticClass: "mt-2", attrs: { title: "Skills (3 Max)" } },
        [
          _c("SkillsMultiselect", {
            attrs: { max: 3, getParentStyle: "customWidthInput" },
            model: {
              value: _vm.skillsIds,
              callback: function ($$v) {
                _vm.skillsIds = $$v
              },
              expression: "skillsIds",
            },
          }),
        ],
        1
      ),
      _c(
        "FormGroup",
        { staticClass: "mt-2", attrs: { title: "Industry" } },
        [
          _c("IndustriesMultiselect", {
            attrs: { multiple: false },
            model: {
              value: _vm.industry,
              callback: function ($$v) {
                _vm.industry = $$v
              },
              expression: "industry",
            },
          }),
        ],
        1
      ),
      _c(
        "FormGroup",
        { staticClass: "mt-2", attrs: { title: "Employment Type" } },
        [
          _c("ExperienceEmploymentTypeSelect", {
            attrs: { getParentStyle: "customWidthInput" },
            model: {
              value: _vm.employmentType,
              callback: function ($$v) {
                _vm.employmentType = $$v
              },
              expression: "employmentType",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pt-5 flex justify-end mt-3" },
        [
          _c("UIButton", {
            staticClass: "mr-3",
            attrs: { variant: "outline", size: "lg", buttonText: "Cancel" },
            on: { click: _vm.closeModal },
          }),
          _vm.isEditing
            ? _c("UIButton", {
                attrs: {
                  buttonText: "Save",
                  variant: "black",
                  size: "lg",
                  disabled: _vm.errors,
                },
                on: { click: _vm.submit },
              })
            : _vm._e(),
          !_vm.isEditing
            ? _c("UIButton", {
                attrs: {
                  buttonText: "Add",
                  variant: "black",
                  size: "lg",
                  disabled: _vm.errors,
                },
                on: { click: _vm.submit },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }